module.exports = __webpack_public_path__ + "static/media/Wallet-balance.a2a39e32.svg";